module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-elektrofahrzeuge-5e60009499b875a828c894acc23cd256.svg";